export function isPromiseLike<T>(
    value: unknown | PromiseLike<T>
): value is PromiseLike<T> {
    return (
        !!value &&
        typeof value === 'object' &&
        'then' in value &&
        typeof value.then === 'function'
    );
}
